import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 0 0 40px 30px;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
